<template>
  <div>
    <v-container>
      <v-card>
        <v-container>
          <input
            id="user-id"
            type="hidden"
            v-model="dado.id"
          />
          <input
            id="dados-usuario"
            type="hidden"
            v-model="dado.usuario"
          />
          <v-row>
            <v-col
              cols="12"
              md="2"
            >
              <v-text-field
                v-model="codigo"
                label="Código"
                outlined
                dense
              >
                <v-btn
                  class="btn-outer-right-1 pa-0"
                  slot="append-outer"
                  color="success"
                  tile
                  @click.prevent="loadDialog"
                >
                  <v-icon
                    class="mx-0"
                    color="white"
                  >
                    mdi-magnify
                  </v-icon>
                </v-btn>
              </v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="3"
              v-if="codigo"
            >
              <v-checkbox
                v-model="dado.inativar"
                label="Inativar dados ?"
                color="success"
              >
              </v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="4"
              v-if="codigo"
            >
              <v-checkbox
                v-model="dado.inativar"
                label="Inativar dados ?"
                color="success"
              >
              </v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              lg="9"
            >
              <v-text-field
                label="Tabela:"
                type="text"
                v-model="dado.tabela"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              lg="9"
            >
              <v-text-field
                label="Caminho do banco:"
                type="text"
                v-model="dado.caminho"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-container class="px-0">
            <v-card>
              <v-card-title>Dados a serem inseridos no banco</v-card-title>
              <v-data-table
                :headers="headers"
                :items="dados"
              >
                <template v-slot:[`item.actions`]="{ item }">
                  <v-icon
                    large
                    color="success"
                    class="mr-2"
                    @click="loadEditPagina(item)"
                  >
                    mdi-square-edit-outline
                  </v-icon>
                </template>
              </v-data-table>
              <v-card-actions class="">
                <v-btn
                  color="success"
                  class="mr-4 text-none"
                  v-if="dado.id"
                  @click="loadAddPage"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Adiciona Página
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-container>
          <v-row class="mt-4">
            <v-col
              cols="12"
              md="10"
              class="pl-6"
            >
              <v-btn
                color="success"
                class="mr-4"
                v-if="!dado.id"
                @click="save"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Salvar
              </v-btn>
              <v-btn
                color="success"
                class="mr-4"
                v-if="dado.id"
                @click="save"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Atualizar
              </v-btn>
              <v-btn
                color="error"
                class="mr-4"
                v-if="dado.id"
                @click="remove"
              >
                <v-icon left>
                  mdi-delete
                </v-icon>
                Deletar
              </v-btn>
              <v-btn
                color="secondary"
                class="mr-4"
                @click="reset"
              >
                <v-icon left>
                  mdi-broom
                </v-icon>
                Limpar
              </v-btn>
            </v-col>
          </v-row>
          <v-row justify="space-around">
            <v-col cols="auto">
              <v-dialog
                v-model="dialog"
                transition="dialog-bottom-transition"
                fullscreen
              >
                <template v-slot:default="dialog">
                  <v-card>
                    <v-toolbar
                      color="primary"
                      dark
                    >
                      Pesquisar dados
                    </v-toolbar>
                    <v-card-title>
                      <v-text-field
                        class="search"
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Pesquisar"
                        single-line
                        hide-details
                      >
                      </v-text-field>
                    </v-card-title>
                    <v-data-table
                      :headers="headers"
                      :items="dados"
                      :search="search"
                    >
                      <template v-slot:[`item.actions`]="{ item }">
                        <v-icon
                          large
                          color="success"
                          class="mr-2"
                          @click="loadPergunta(item)"
                        >
                          mdi-square-edit-outline
                        </v-icon>
                      </template>
                    </v-data-table>
                    <v-card-actions class="justify-end">
                      <v-btn
                        color="error"
                        @click="dialog.value = false"
                      >Fechar</v-btn>
                    </v-card-actions>
                  </v-card>
                </template>
              </v-dialog>
            </v-col>
          </v-row>
        </v-container>
        <!-- Dialog de filtro de páginas -->
        <v-container>
          <v-dialog
            v-model="dialogPaginas"
            transition="dialog-bottom-transition"
            fullscreen
          >
            <template v-slot:default="dialogPaginas">
              <v-card>
                <v-toolbar
                  color="primary"
                  dark
                >
                  Pesquisar páginas
                </v-toolbar>
                <v-card-title>
                  <v-text-field
                    class="search"
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Pesquisar"
                    single-line
                    hide-details
                  >

                  </v-text-field>
                </v-card-title>
                <v-data-table
                  :headers="headerPages"
                  :items="paginas"
                  :search="search"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-icon
                      large
                      color="success"
                      class="mr-2"
                      @click="loadSelPaginas(item)"
                    >
                      mdi-arrow-down-bold-box
                    </v-icon>
                  </template>
                </v-data-table>
                <v-card-actions class="justify-end">
                  <v-btn
                    color="error"
                    @click="dialogPaginas.value = false"
                  >Fechar</v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-dialog>
        </v-container>
        <!-- Dialog de vincular dados à página -->
        <v-container>
          <v-dialog
            v-model="DialogPagina"
            transition="dialog-top-transition"
          >
            <v-card tile>
              <v-toolbar
                color="primary"
                dark
                class="mb-2"
              >
                Adicionar dados à pagina do site
              </v-toolbar>
              <div class="ml-4 mt-5">
                <v-form>
                  <input
                    id="user-id"
                    type="hidden"
                    v-model="ppmovim.usuario"
                  />
                  <input
                    id="uuid-id"
                    type="hidden"
                    v-model="ppmovim.uid_dados"
                  />
                  <input
                    id="pagina-id"
                    type="hidden"
                    v-model="ppmovim.id"
                  />
                  <v-row>
                    <v-col
                      cols="12"
                      md="3"
                      lg="2"
                    >
                      <v-text-field
                        v-model="codigo"
                        label="Código da dados"
                        dense
                        outlined
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="3"
                      lg="2"
                      v-if="codMove"
                    >
                      <v-text-field
                        v-model="codMove"
                        label="Código do movimento"
                        dense
                        outlined
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      sm="12"
                      md="6"
                    >
                      <v-text-field
                        label="Página da dados:"
                        v-model="pagina.titulo"
                        required
                        dense
                        outlined
                      >
                        <v-btn
                          class="btn-outer-right-1 pa-0"
                          slot="append-outer"
                          color="success"
                          tile
                          @click.prevent="loadDialogPaginas"
                        >
                          <v-icon
                            class="mx-0"
                            color="white"
                          >
                            mdi-magnify
                          </v-icon>
                        </v-btn>
                      </v-text-field>
                      <input
                        id="uid_page"
                        type=hidden
                        v-model="ppmovim.uid_pagina"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="4"
                      v-if="codigo"
                    >
                      <v-checkbox
                        v-model="ppmovim.visivel"
                        label="Visualizar dados ?"
                        color="success"
                      >
                      </v-checkbox>
                    </v-col>
                  </v-row>
                </v-form>
              </div>
              <v-card-actions class="justify-end">
                <v-btn
                  color="success"
                  class="mr-4"
                  v-if="ppmovim.id"
                  type="submit"
                  @click.prevent="addPagina()"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Atualizar
                </v-btn>
                <v-btn
                  color="success"
                  class="mr-4"
                  v-if="!ppmovim.id"
                  type="submit"
                  @click.prevent="addPagina()"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Adicionar
                </v-btn>
                <v-btn
                  color="error"
                  class="mr-4"
                  v-if="ppmovim.id"
                  @click.prevent="removePagina()"
                >
                  Remover
                  <v-icon left>
                    mdi-delete
                  </v-icon>
                </v-btn>
                <v-btn
                  color="danger"
                  class="mr-4"
                  @click="closeDialog"
                >
                  Sair
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-container>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { baseApiUrl, showError } from '@/global'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import dtmenu from '../../data/menu'
import axios from 'axios'
export default {
  name: 'CatComponent',
  computed: mapState(['user']),
  data: () => ({
    uuid: '',
    tabs: null,
    codigo: '',
    codMove: '',
    editor: ClassicEditor,
    editorConfig: {
    },
    dialog: false,
    DialogPagina: false,
    dialogPaginas: false,
    tabela: 'dadoss_frequentes',
    search: '',
    dado: {},
    dadoss: [],
    pagina: {},
    paginas: [],
    dados: dtmenu,
    ppmovim: {},
    length: '',
    headers: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome', value: 'nome' },
      { text: 'Menu', value: 'menu' },
      { text: 'Chave', value: 'parentId', sortable: false },
      { text: 'Url', value: 'url_int', sortable: false },
      { text: 'Subtitulo', value: 'subtitulo', sortable: false }
    ]
  }),
  methods: {
    save () {
      const method = this.dado.id ? 'put' : 'post'
      const id = this.dado.id ? `/${this.dado.id}` : ''
      axios[method](`${baseApiUrl}/${this.dado.caminho}${id}`, this.dados)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.reset()
        })
        .catch(showError)
    },

    addPagina () {
      const method = this.ppmovim.id ? 'put' : 'post'
      const id = this.ppmovim.id ? `/${this.ppmovim.id}` : ''
      axios[method](`${baseApiUrl}/paginas-param-movimento${id}`, this.ppmovim)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.closeDialog()
          this.loadPpMovim(this.dado.id)
        })
        .catch(showError)
    },

    removePagina () {
      const id = this.ppmovim.id
      alert('Deseja realmente desvincular a dados?')
      axios.delete(`${baseApiUrl}/paginas-param-movimento/${id}`)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.closeDialog()
          this.loadPpMovim(this.dado.id)
        })
        .catch(showError)
    },

    remove () {
      const id = this.dado.id
      alert('Deseja realmente remover a dados?')
      axios.delete(`${baseApiUrl}/dadoss-e-respostas/${id}`)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.reset()
        })
        .catch(showError)
    },
    loadSelPaginas (item) {
      const id = this.codPagina ? this.codPagina : item.id
      const url = `${baseApiUrl}/paginas-param/${id}`
      axios.get(url).then(res => {
        this.pagina = res.data
        this.ppmovim.uid_pagina = this.pagina.id
      })
      this.dialogPaginas = false
    },
    loadPaginas () {
      const url = `${baseApiUrl}/paginas-param`
      axios.get(url).then(res => {
        this.paginas = res.data.map(item => {
          return {
            ...item,
            status: item.inativar === 0 ? 'Ativo' : 'Inativo'
          }
        })
      })
    },
    loadPpMovim (uid) {
      const url = `${baseApiUrl}/movimento-por-dados/${uid}`
      axios.get(url).then(res => {
        this.dados = res.data.map(item => {
          return {
            ...item,
            visualizar: item.visivel === 0 ? 'Não' : 'Sim'
          }
        })
      })
    },
    loadEditPagina (item) {
      const uid = item.id
      const url = `${baseApiUrl}/paginas-param-movimento/${uid}`
      axios.get(url).then(res => {
        this.ppmovim = res.data
        this.codMove = this.ppmovim.id
        this.pagina.titulo = this.ppmovim.titulo
      })
      this.DialogPagina = true
    },
    loadDialogPaginas () {
      this.dialogPaginas = true
      this.codPagina = ''
      this.loadPaginas()
    },
    loadPerguntas () {
      const url = `${baseApiUrl}/dadoss-e-respostas`
      axios.get(url).then(res => {
        this.dadoss = res.data.map(item => {
          return {
            ...item,
            status: item.inativar === 0 ? 'Ativo' : 'Inativo',
            geral: item.geral === 0 ? 'Não' : 'Sim'
          }
        })
      })
    },
    loadPergunta (item) {
      const id = item.id
      const url = `${baseApiUrl}/dadoss-e-respostas-update/${id}`
      axios.get(url).then(res => {
        this.dados = res.data
        this.codigo = this.dado.id
        const uid = this.dado.id
        this.loadPpMovim(uid)
      })
      this.dialog = false
    },
    reset () {
      this.dados = {}
      this.pagina = {}
      this.dados = []
      this.codigo = ''
      this.loadUser()
    },
    loadDialog () {
      this.dialog = true
      this.loadPerguntas()
    },
    loadAddPage () {
      this.DialogPagina = true
      this.ppmovim.uid_dados = this.dado.id
      this.ppmovim.usuario = this.user.id
    },
    closeDialog () {
      this.DialogPagina = false
      this.pagina = {}
      this.ppmovim = {}
      this.codMove = ''
    },
    loadUser () {
      this.dado.usuario = this.user.id
    }
  },
  created () {
    this.loadUser()
  }
}
</script>

<style scoped>
.btn-outer {
  margin-top: -7px !important;
  margin-left: -9px !important;
}
.btn-outer-right {
  margin-top: -7px !important;
  margin-right: -13px !important;
}
.btn-outer-right-1 {
  margin-top: -8px !important;
  margin-left: -12px !important;
  border-top: solid 1px #878f97 !important;
  border-right: solid 1px #878f97 !important;
  border-bottom: solid 1px #878f97 !important;
}
.v-size--default {
  height: 39px !important;
  min-width: 38px !important;
}
</style>
